import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import Routes from './routes';
import { renderRoutes } from 'react-router-config';
import { ThemeProvider } from '@material-ui/styles';
import { themeGreen } from './theme';
import * as serviceWorker from './serviceWorker';


export default function Main() {
  const [mainTheme, setMainTheme] = React.useState(themeGreen);


  return (
    <React.StrictMode>
      <BrowserRouter basename='/reviews/'>
          <ThemeProvider theme={mainTheme}>  
            <div>{renderRoutes(Routes)}</div>
          </ThemeProvider>        
      </BrowserRouter>
    </React.StrictMode>
  )
}

ReactDOM.render(
  <Main/>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
